import OrganizationVLAZE from "../assets/images/organization/organizationVLAZE.png";
import OrganizationONE from "../assets/images/organization/organizationONE.png";
import OrganizationJIEUN from "../assets/images/organization/organizationJIEUN.png";
import OrganizationEUNHYE from "../assets/images/organization/organizationEUNHYE.jpeg";

// S ::::: 조직도 강사진 ::::: S
export const organizationLists = [
  {
    img: OrganizationVLAZE,
    name: "박지원",
    subTitle: [
      "넵튠 댄스스튜디오 대표",
      "IPIDIA 국제실용댄스지도자협회 협회장",
    ],
    instagram: "https://www.instagram.com/vlazeon/",
    contents: [
      "- 뉴오더 엔터테인먼트 트레이너 출강",
      "- 어트랙트 엔터테인먼트 댄스트레이너",
      "- 스타크루ENT 엔터테인먼트 댄스트레이너",
      "- LM 엔터테인먼트 댄스트레이너",
      "- 레인보우ENM 댄스트레이너",
      "- 안녕뮤직 엔터테인먼트 댄스트레이너",
      "- 한국예술학교 실용무용 출강",
      "- 오리엔탈 서울 VOL.6 실용무용대회 심사",
      "- 아시아희망캠프기구 글로벌오디션 심사",
      "- 걸그룹 피프티피프티 트레이닝",
      "- 걸스플래닛 참가자 모모코 연습생 트레이닝",
      "- 다이아 기희현, 예빈 트레이닝",
      "- 러블리즈 서지수 트레이닝",
      "- 루나솔라 지안 트레이닝",
      "- HUB 효선 비주얼디렉팅 & 트레이닝",
      "- 슈퍼스타 K4 리틀GOD 트레이닝",
      "- MNET 언프리티랩스타2 콘서트",
      "- 오리엔탈 서울 VOV.6 갈라쇼 초청공연",
      "- MNET 언프리티랩스타2 [안수민] 무대 퍼포먼스 연출",
      "- KBS 더유닛 [HUB 효선] 퍼포먼스 디렉팅 & 트레이닝",
      "- KBS 더유닛 [레드팀] 퍼포먼스 리디렉팅",
      "- JTBC 믹스나인 [루이] 퍼포먼스 디렉팅 및 트레이닝",
      "- SIWA 국제여성협회 여성의날 댄스퍼포먼스 연출",
      "- 다수 입시 및 오디션 합격생 배출",
    ],
  },
  // {
  //   img: OrganizationONE,
  //   name: "김시원",
  //   subTitle: ["IPDIA 국제실용댄스지도자협회 교육위원장"],
  //   instagram: "https://www.instagram.com/s__one99/",
  //   contents: [
  //     "- 2017 Slag D Street 솔로퍼포먼스부문 3rd",
  //     "- 2017 부산 국제무용제 오프닝 초청 무대",
  //     "- 2018 드림콘서트 ‘24k’ 백업",
  //     "- 2018 국군의 날 70주년 ’싸이‘ 백업",
  //     "- 2019 해운대구 청소년 경진대회 댄스부문 최우수",
  //     "- 2019 ‘The Beginning Uprising’ 퍼포먼스 디렉터",
  //     "- 2019 부산광역시 해운대구 축제기획단 단장",
  //     "- 2019 원어스 ’가자‘ MV 촬영",
  //     "- 2022 SNACKER Vol.1 Winner",
  //     "- 2022 New Age 일반부 3rd (House Dance Performance)",
  //     "- 2022 King of Kookje Vol.2 Guest show",
  //     "- 2023 FROM ROOTS Vol.2 Guest show",
  //     "- 2023 KDF vol.1 Guest show",
  //     "- 2023 KDF vol.1 Best ",
  //     "- 2023 TONE Guest Show",
  //     "- 2023 King of Kookje vol.4 Best 4",
  //     "- 2023 카자흐스탄 영재교육원 K-pop 단체 레슨 (178명)",
  //     "- 2024 KDF vol.2 MC",
  //     "- 2024 Dancing in my room vol.1 2nd place",
  //     "- 2024 King of Kookje vol.5 MC",
  //     "- 2024 Chess vol.1 MC",
  //     "- 2024 Maximum Bounce MC",
  //     "- 다수 배틀 수상 경력",
  //   ],
  // },
  {
    img: OrganizationJIEUN,
    name: "이지은",
    subTitle: ["IPDIA 국제실용댄스지도자협회 교육위원회"],
    instagram: "",
    contents: [
      "- IPDIA 국제실용댄스지도자협회 교육위원회",
      "- MNH 엔터테인먼트 청하 댄스트레이너",
      "- 식스오션스 엔터테인먼트 2AM창민 댄스트레이너",
      "- 크롬 엔터테인먼트 트레이너 및 안무가",
      "- 네가네트워크 라붐,LC9 트레이너 및 안무가",
      "- 브라운아이드 걸스 백업",
      "- 걸그룹 라붐 안무참여 및 디렉팅",
      "- 걸그룹 크레용팝 안무참여 및 디렉팅",
      "- HY 댄스스튜디오 코레오 강사",
      "- 아임뉴댄스스튜디오 코레오, KPOP 강사",
      "- MOVE 댄스스튜디오 홍대점 코레오 강사",
      "- 코리아갓탤런트1 공연",
      "- 언프리티랩스타2 콘서트 공연",
      "- 2018 평창 동계올림픽 폐막식 공연",
      "- 다수 입시 합격생 배출",
    ],
  },
  {
    img: OrganizationEUNHYE,
    name: "최은혜",
    subTitle: ["IPDIA 국제실용댄스지도자협회 교육위원회"],
    instagram: "https://www.instagram.com/ehmrzze/",
    contents: [
      "- IPDIA 국제실용댄스지도자협회 교육위원회",
      "- Planet8 댄스학원 강사",
      "- 현재 다수 학교 및 기관 출강",
      "- 레인보우ENM 댄스트레이너",
      "- 전) YN 댄스아카데미 강사",
      "- 전) BK dance 강사",
      "- Street all round championship 대상",
      "- I’m a dancer vol.4 대상",
      "- Up&down vol.2 대상",
      "- K-teen 최우수",
      "- 서울종합예술학교 퍼포먼스 dance battle 우수상",
      "- Bring it guest show",
      "- Royal straight flush vol.1 guestshow",
      "- Show me the passion guestshow",
      "- Adrenalin rush vol.2 2nd",
    ],
  },
];
// E ::::: 조직도 강사진 ::::: E
